export enum CreateUserFormFields {
  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
  Password = "password",
  ExcludeFromReports = "excludeFromReports",
  ReferralCode = "referralCode",
  CompanyName = "companyName",
}

export const CreateUserFormFieldsList = [
  CreateUserFormFields.FirstName,
  CreateUserFormFields.LastName,
  CreateUserFormFields.Email,
  CreateUserFormFields.Password,
  CreateUserFormFields.ExcludeFromReports,
  CreateUserFormFields.ReferralCode,
  CreateUserFormFields.CompanyName,
];
